import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { MenuPosition } from '../menuPosition/menuPosition.component';

export const Container: StyledComponent<'div'> = styled.div`
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${Color.Gray300};
  border-bottom: 1px solid ${Color.Gray300};
`;

export const StyledMenuPosition: StyledComponent<typeof MenuPosition> = styled(MenuPosition)`
  padding: 21px 0;
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.3s;

  & + & {
    border-top: 1px solid ${Color.Gray300};
  }

  &:hover {
    background-color: ${Color.Gray100};
  }
`;
